<template>
  <v-container>
    <!-- page header -->

    <v-row>
      <v-col cols="12" md="8">
        <h1 class="display-1">All Bookings</h1>
      </v-col>

      <v-col cols="12" md="4" align="end">
        <v-btn depressed color="primary" to="/">Home</v-btn>
      </v-col>
    </v-row>

    <!-- page header -->

    <!-- screen options -->

    <v-row>
      <v-col cols="12" md="3"
        ><v-switch
          v-model="viewConfirmed"
          dense
          inset
          hide-details
          label="View Confirmed Bookings"
        ></v-switch
      ></v-col>

      <v-col cols="12" md="3"
        ><v-switch
          v-model="viewArchived"
          dense
          inset
          hide-details
          label="View Archived Bookings"
        ></v-switch
      ></v-col>

      <v-col cols="12" md="3">
        <v-btn
          class="ml-4"
          color="primary"
          depressed
          @click="openCustomRequestDialog"
        >
          (+) Custom Request
        </v-btn>
      </v-col>
    </v-row>

    <!-- screen options -->

    <!-- active/unconfirmed data table -->

    <v-row
      ><v-col cols="12">
        <v-card outlined>
          <v-card-text class="text--primary">
            <v-row>
              <v-col cols="12" md="7">
                <h3 class="title">Active/Unconfirmed Bookings</h3>
              </v-col>

              <v-col cols="12" md="5">
                <v-text-field
                  label="Search Active/Unconfirmed"
                  v-model="searchActiveUnconfirmed"
                  dense
                  outlined
                  clearable
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            :headers="headers"
            :items="activeBookings"
            dense
            :search="searchActiveUnconfirmed"
            :items-per-page="-1"
            :item-class="itemClass"
            @click:row="onViewBooking"
            hide-default-footer
          >
            <template v-slot:[`item.checkInDate`]="{ item }">
              {{ formatDate(item.checkInDate) }}
            </template>

            <template v-slot:[`item.checkOutDate`]="{ item }">
              {{ formatDate(item.checkOutDate) }}
            </template>

            <template v-slot:[`item.dateConfirmed`]="{ item }">
              {{ formatDate(item.dateConfirmed) }}
            </template>

            <template v-slot:[`item.lockStatus`]="{ item }">
              <v-chip
                v-if="isBookingLocked(item)"
                small
                color="warning"
                text-color="black"
              >
                In Progress — {{ item.lockedByName || "Staff" }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col></v-row
    >

    <!-- active/unconfirmed data table -->

    <!-- confirmed data table -->

    <v-fade-transition>
      <v-row v-if="viewConfirmed"
        ><v-col cols="12">
          <v-card outlined>
            <v-card-text class="text--primary">
              <v-row>
                <v-col cols="12" md="7">
                  <h3 class="title">Confirmed Bookings</h3>
                </v-col>

                <v-col cols="12" md="5">
                  <v-text-field
                    label="Search Confirmed"
                    v-model="searchConfirmed"
                    dense
                    outlined
                    clearable
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              :headers="headers"
              :items="confirmedBookings"
              dense
              :search="searchConfirmed"
              :items-per-page="-1"
              :item-class="itemClass"
              @click:row="onViewBooking"
              hide-default-footer
            >
              <template v-slot:[`item.checkInDate`]="{ item }">
                {{ formatDate(item.checkInDate) }}
              </template>

              <template v-slot:[`item.checkOutDate`]="{ item }">
                {{ formatDate(item.checkOutDate) }}
              </template>

              <template v-slot:[`item.dateConfirmed`]="{ item }">
                {{ formatDate(item.dateConfirmed) }}
              </template>

              <template v-slot:[`item.lockStatus`]="{ item }">
                <v-chip
                  v-if="isBookingLocked(item)"
                  small
                  color="warning"
                  text-color="black"
                >
                  In Progress — {{ item.lockedByName || "Staff" }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card>
        </v-col></v-row
      >
    </v-fade-transition>

    <!-- confirmed data table -->

    <!-- archived data table -->

    <v-fade-transition>
      <v-row v-if="viewArchived"
        ><v-col cols="12">
          <v-card outlined>
            <v-card-text class="text--primary">
              <v-row>
                <v-col cols="12" md="7">
                  <h3 class="title">Archived Bookings</h3>
                </v-col>

                <v-col cols="12" md="5">
                  <v-text-field
                    label="Search Archived"
                    v-model="searchArchived"
                    dense
                    outlined
                    clearable
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              :headers="headers"
              :items="archivedBookings"
              dense
              :search="searchArchived"
              :items-per-page="-1"
              :item-class="itemClass"
              @click:row="onViewBooking"
              hide-default-footer
            >
              <template v-slot:[`item.checkInDate`]="{ item }">
                {{ formatDate(item.checkInDate) }}
              </template>

              <template v-slot:[`item.checkOutDate`]="{ item }">
                {{ formatDate(item.checkOutDate) }}
              </template>

              <template v-slot:[`item.dateConfirmed`]="{ item }">
                {{ formatDate(item.dateConfirmed) }}
              </template>

              <template v-slot:[`item.lockStatus`]="{ item }">
                <v-chip
                  v-if="isBookingLocked(item)"
                  small
                  color="warning"
                  text-color="black"
                >
                  In Progress — {{ item.lockedByName || "Staff" }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card>
        </v-col></v-row
      >
    </v-fade-transition>

    <!-- archived data table -->

    <v-dialog v-model="bookingLockDialog" max-width="500">
      <v-card>
        <v-card-title>Booking In Progress</v-card-title>
        <v-card-text>
          This booking is locked by
          <strong>{{
            selectedLockedBooking &&
              (selectedLockedBooking.lockedByName || "another team member")
          }}</strong
          >. You may view it, but cannot make changes until the lock expires or
          is released.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="bookingLockDialog = false">Cancel</v-btn>
          <v-btn color="warning" text @click="viewLockedBooking"
            >View Anyways</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Custom Request: PUID Recognition -->

    <v-dialog v-model="customRequestDialog" max-width="520">
      <v-card :loading="customRequestLoading">
        <v-card-title class="text-h6">Create Custom Request</v-card-title>

        <v-card-text class="text--primary">
          <p class="mb-4">
            Enter a PUID to attach this custom request to a traveler’s
            registered package.
          </p>

          <v-text-field
            label="PUID"
            v-model.trim="customRequestPuid"
            outlined
            dense
            clearable
            :disabled="customRequestLoading"
            @keyup.enter="recognizePuid"
          />

          <v-alert
            v-if="customRequestError"
            type="error"
            outlined
            text
            class="mt-3"
          >
            {{ customRequestError }}
          </v-alert>

          <v-alert
            v-if="recognizedUserAccount"
            type="success"
            outlined
            text
            class="mt-3"
          >
            Recognized:

            <strong>
              {{ recognizedUserAccount.firstName }}

              {{ recognizedUserAccount.lastName }}
            </strong>

            — {{ recognizedUserAccount.email }}
          </v-alert>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="closeCustomRequestDialog"
            :disabled="customRequestLoading"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            depressed
            @click="recognizePuid"
            :loading="customRequestLoading"
            :disabled="customRequestLoading"
          >
            Recognize PUID
          </v-btn>

          <v-btn
            color="success"
            depressed
            @click="continueToCustomRequest"
            :disabled="!recognizedUserAccount || customRequestLoading"
          >
            Continue
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import firebase from "@/plugins/firebase";

import formatDate from "@/mixins/formatDate";

import moment from "moment";

import { can } from "@/services/auth";

const userAccounts = firebase.firestore().collection("userAccounts");

const mps = firebase.firestore().collection("mps");

export default {
  mixins: [formatDate],

  firestore: {
    bookings: firebase

      .firestore()

      .collection("bookingsConfirmations")

      .orderBy("dateConfirmed", "desc"),
  },

  data: () => ({
    bookings: [],

    searchActiveUnconfirmed: "",

    searchConfirmed: "",

    searchArchived: "",

    viewConfirmed: false,

    viewArchived: false,

    headers: [
      { text: "Last Name", value: "lastName" },
      { text: "Lock Status", value: "lockStatus", sortable: false },

      { text: "Email", value: "email" },

      { text: "Destination", value: "destination" },

      { text: "Resort Name", value: "resortName" },

      { text: "Check In Date", value: "checkInDate" },

      { text: "Check Out Date", value: "checkOutDate" },

      { text: "Date Confirmed", value: "dateConfirmed" },

      { text: "Confirmation #", value: "confirmationNumber" },

      { text: "Supplier", value: "source" },
    ],

    customRequestDialog: false,

    customRequestLoading: false,

    customRequestPuid: "",

    customRequestError: "",

    recognizedUserAccount: null,
    bookingLockDialog: false,
    selectedLockedBooking: null,
    lockClock: Date.now(),
  }),

  computed: {
    currentUser() {
      return this.$store && this.$store.state ? this.$store.state.user : null;
    },

    currentUid() {
      var u = this.currentUser;

      return u && u.uid ? u.uid : "";
    },

    // Mgmt behavior (and legacy super admin) can see everything.

    canViewAllBookings() {
      return (
        can(this.currentUser, this.$store, "reassignPuid") ||
        can(this.currentUser, this.$store, "assumePuid")
      );
    },

    // Apply ownership filtering for non-mgmt

    visibleBookings() {
      if (!this.bookings) return [];

      if (this.canViewAllBookings) return this.bookings;

      var uid = this.currentUid;

      if (!uid) return [];

      // Only show items explicitly assigned to them.

      // (Old bookings without assignedToUid won't show for non-mgmt.)

      return this.bookings.filter((b) => b && b.assignedToUid === uid);
    },

    activeBookings() {
      return this.visibleBookings.filter((i) => !i.isConfirmed && !i.archived);
    },

    confirmedBookings() {
      return this.visibleBookings.filter((i) => i.isConfirmed && !i.archived);
    },

    archivedBookings() {
      return this.visibleBookings.filter((i) => i.archived);
    },
  },

  mounted() {
    this.bookingLockClockInterval = setInterval(() => {
      this.lockClock = Date.now();
    }, 15000);
  },
  beforeDestroy() {
    clearInterval(this.bookingLockClockInterval);
  },
  methods: {
    lockMillis(value) {
      if (!value) return 0;
      if (typeof value.toMillis === "function") return value.toMillis();
      if (typeof value.toDate === "function") return value.toDate().getTime();
      const date = new Date(value);
      return isNaN(date.getTime()) ? 0 : date.getTime();
    },
    isBookingLocked(item) {
      return !!(
        item &&
        item.locked &&
        this.lockMillis(item.lockedAt) &&
        this.lockClock - this.lockMillis(item.lockedAt) < 60 * 60 * 1000
      );
    },
    viewLockedBooking() {
      const item = this.selectedLockedBooking;
      this.bookingLockDialog = false;
      this.selectedLockedBooking = null;
      if (item) this.$router.push(`/bookings/${item.id}`);
    },

    itemClass(item) {
      if (this.isBookingLocked(item)) return "yellow lighten-4";

      var today = moment().startOf("day");

      var checkOutDate = moment(item.checkOutDate);

      if (item.isConfirmed && checkOutDate.isAfter(today))
        return "green lighten-4";

      if (item.isConfirmed && checkOutDate.isBefore(today))
        return "grey lighten-2";

      return "";
    },

    onViewBooking(item) {
      if (this.isBookingLocked(item) && item.lockedBy !== this.currentUid) {
        this.selectedLockedBooking = item;
        this.bookingLockDialog = true;
        return;
      }
      this.$router.push(`bookings/${item.id}`);
    },

    openCustomRequestDialog() {
      this.customRequestDialog = true;

      this.customRequestLoading = false;

      this.customRequestPuid = "";

      this.customRequestError = "";

      this.recognizedUserAccount = null;
    },

    closeCustomRequestDialog() {
      this.customRequestDialog = false;
    },

    normalizePuid(puid) {
      return (puid || "").toString().trim();
    },

    async recognizePuid() {
      this.customRequestError = "";

      this.recognizedUserAccount = null;

      const puid = this.normalizePuid(this.customRequestPuid);

      if (!puid) {
        this.customRequestError = "Invalid PUID";

        return;
      }

      this.customRequestLoading = true;

      try {
        // 1) Registered = userAccount exists

        let uaSnap = await userAccounts

          .where("packageID", "==", puid)

          .limit(1)

          .get();

        if (!uaSnap.empty) {
          const doc = uaSnap.docs[0];

          this.recognizedUserAccount = { id: doc.id, ...doc.data() };

          this.customRequestLoading = false;

          return;
        }

        // 2) Exists in MPS but no userAccount = not registered

        let mpsSnap = await mps

          .where("puid", "==", puid)

          .limit(1)

          .get();

        if (!mpsSnap.empty) {
          this.customRequestError = "This Package Is Not Registered";

          this.customRequestLoading = false;

          return;
        }

        // 3) Not found anywhere

        this.customRequestError = "Invalid PUID";
      } catch (e) {
        console.error("recognizePuid error", e);

        this.customRequestError = "Invalid PUID";
      } finally {
        this.customRequestLoading = false;
      }
    },

    continueToCustomRequest() {
      if (!this.recognizedUserAccount) return;

      const puid = this.normalizePuid(this.customRequestPuid);

      this.customRequestDialog = false;

      this.$router.push({
        path: "/bookings/new",

        query: {
          ua: this.recognizedUserAccount.id,
        },
      });
    },
  },
};
</script>

<style>
table {
  width: 100%;

  table-layout: fixed;
}

tr {
  cursor: pointer;
}
</style>
